import styled from 'styled-components'
import { Text } from 'components'
import { GLOBAL_COLORS } from 'theme'

const ColoredTriangle = styled.div<{ isPositive: boolean }>`
  width: 0;
  height: 0;
  border-left: 10px solid ${GLOBAL_COLORS.transparent};
  border-right: 10px solid ${GLOBAL_COLORS.transparent};
  border-top: 10px solid
    ${({ isPositive }) => (isPositive ? GLOBAL_COLORS.canopyGreen : GLOBAL_COLORS.volcanoRed)};
  transform: rotate(${({ isPositive }) => (isPositive ? '180deg' : '0deg')});
`

const Info = styled.div`
  border: 1px solid ${GLOBAL_COLORS.black};
  padding: 10px;
  margin: 10px;
  display: flex;
  justify-content: center;
`

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  margin-right: 10px;
`

const Stick = styled.div<{ width: number }>`
  border-top: 1px solid;
  width: ${({ width }) => width}px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const BoxData = styled.div<{ marginTop: number }>`
  margin-top: ${(props) => props.marginTop}px;
`

const RoundingText = styled(Text)`
  color: ${({ theme }) => theme.seashellWhite05ToCoreGrey};
`

const CustomText = styled(Text)<{ headingStyle?: string }>`
  margin: 0;
  display: flex;
  ${(props) => {
    if (props.headingStyle === 'main') {
      return `color: ${props.theme.whiteToCoreGrey};`
    }
    return `color: ${props.theme.seashellWhite05ToCoreGrey};`
  }}
`

export { Info, ColoredTriangle, LogoWrapper, Wrapper, Stick, CustomText, RoundingText, BoxData }
